module.exports = __webpack_public_path__ + "img/Screenshot_2021-10-28-16-03-37-541_com.pinkcoffee.sexbattle.c25680a6.jpg";